/* This file is autogenerated by @oui/cli */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Svg, { Path } from "react-native-svg";
var SvgComponent = function(props) {
    return /*#__PURE__*/ _jsxs(Svg, _object_spread_props(_object_spread({
        width: 18,
        height: 17,
        viewBox: "0 0 18 17",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx(Path, {
                d: "M9.93 11.42v2.46a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3c0-1.1.9-2 2-2h4.93a2 2 0 0 1 2 2v.8",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                vectorEffect: "non-scaling-stroke"
            }),
            /*#__PURE__*/ _jsx(Path, {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.47 14.4a1.12 1.12 0 1 0 0-2.24 1.12 1.12 0 0 0 0 2.24",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx(Path, {
                d: "M4.72 3.23h1.49",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                vectorEffect: "non-scaling-stroke"
            }),
            /*#__PURE__*/ _jsx(Path, {
                d: "M16.11 9.99A3 3 0 0 1 15.37 8V5.88a3.02 3.02 0 1 0-6.04 0v2.13A3 3 0 0 1 8.58 10L7.7 11H17z",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                vectorEffect: "non-scaling-stroke"
            }),
            /*#__PURE__*/ _jsx(Path, {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.42 10.77q-.23.3-.23.7a1.16 1.16 0 1 0 2.09-.7z",
                fill: "currentColor"
            })
        ]
    }));
};
export default SvgComponent;
